const tokenMiddleware = options => store => next => action => {
  if (!action){
    action = { type: '' }
  }
  const { 
    client,
    customHeaders = ['Authorization'], 
    validateAction = 'VALIDATE_TOKEN',  
    logoutAction = 'LOGOUT',  
  } = options;
  const HEADERS = [...new Set([...customHeaders])];
  if (action.type === validateAction) {
    const { headers } = action;
    if (headers) {
      if(headers['Authorization']) {
        HEADERS.forEach( async token => {
          localStorage.setItem(token, headers[token]);
          client.defaults.headers.common[token] = `Bearer ${headers[token]}`;
        })
      }
    }
  } else if (action.type === logoutAction) {
      HEADERS.forEach( token => localStorage.removeItem(token));
  } else {
    HEADERS.forEach( async token => {
      const key = localStorage.getItem(token);
      client.defaults.headers.common[token] = `Bearer ${key}`
  });
  }
  return next(action)
}

export default tokenMiddleware


// WEBPACK FOOTER //
// ./src/store/middlewares/auth.js